import $ from 'jquery';
import checkMetamask from './checkMetamask';
import getNfsgContract from './getNfsgContract';
import getNfsgxContract from './getNfsgxContract';

const checkMyWalletBar = async () => {
  if (!$('.js-my-wallet-bar').length) {
    return;
  }

  $('.js-my-wallet-bar a').each((inde, element) => {
    const $that = $(element);
    const path = window.location.pathname;
    console.log(path);
    console.log($that.attr('href'));
    if ($that.attr('href') === path) {
      $that.closest('li').addClass('is-checked');
    }
  });

  // if (!await checkMetamask()) {
  //   return;
  // }

  const accounts = await web3Client.eth.getAccounts();
  const contract = getNfsgContract();
  const contractNfsgx = getNfsgxContract();
  const balance = await contract.methods.balanceOf(accounts[0]).call();
  const balanceNfsgx = await contractNfsgx.methods.balanceOf(accounts[0]).call();
  $('#on-chain-balance').text((balance / 1000000)?.toFixed(2));
  $('#on-chain-balance-nfsgx').text((balanceNfsgx / 1000000)?.toFixed(2));
};

export default checkMyWalletBar;
